/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Similar/view.blocks to change it.
import Details from './Details/index'
import DetailsAction from './DetailsAction/index'
import Info from './Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Similar({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Check/Content/Patients/Similar"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Similar.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Info
  viewPath={`${viewPath}/Info`}
/>
<DetailsAction
  viewPath={`${viewPath}/DetailsAction`}
/>
</div>
<Details
  viewPath={`${viewPath}/Details`}
/>
{children}
</React.Fragment>)
}